module.exports = __webpack_public_path__ + "static/media/loanClousre.82192105.svg";